// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__gItlJ","header":"Messages_header__3V4dG"};